import { ReactNode } from "react";
import {
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Modal as ChakraModal,
  ModalProps,
} from "@chakra-ui/react";

import { ChakraText } from "components/ChakraText";
import { Button } from "components/Button";

interface IProps extends ModalProps {
  isOpen: boolean;
  onClose: () => void;
  modalHeader: ReactNode;
  modalFooterButtons?: ReactNode;
}

const Modal = ({
  isOpen,
  onClose,
  children,
  modalHeader,
  modalFooterButtons,
  ...restProps
}: IProps) => {
  return (
    <ChakraModal
      blockScrollOnMount={false}
      isOpen={isOpen}
      onClose={onClose}
      {...restProps}
    >
      <ModalOverlay />
      <ModalContent pb={4}>
        <ModalHeader>{modalHeader}</ModalHeader>
        <ModalCloseButton id="close-modal-top-btn" />
        <ModalBody>{children}</ModalBody>

        <ModalFooter>{modalFooterButtons}</ModalFooter>
        <Button
          id="close-modal-btn"
          onClick={onClose}
          w="250px"
          colorScheme="red"
          variant="outline"
          m="auto"
        >
          <ChakraText>Zamknij</ChakraText>
        </Button>
      </ModalContent>
    </ChakraModal>
  );
};

export { Modal };
